module.exports = __webpack_public_path__ + "static/jardin-3c987b089a88e680223d92d040468419.jpg";